<template>
  <div>
    <template v-if="isLoggedIn && user.item_activated">
      <h1 class="mb-6">Einstellungen</h1>

      <section class="bg-grey-lighter p-4 rounded border-l-4 border-green-heinz ">
        <h2 class="border-0 text-xl">Freunde glücklich machen ❤️</h2>
        Wir schenken dir jeden Monat <strong>3 Gutscheincodes</strong> á 5,00 € für neue foodi.de Freunde!<sup>*</sup><br />
        Für jeden eingelösten Gutschein schicken wir dir ebenfalls einen 5,00 € Gutschein für deine nächste Bestellung!<br />
        <span class="italic text-sm"><sup>*</sup>Mindestbestellwert 10,00 €, zwei Wochen gültig und nur für neue Nutzer, die bisher noch kein Konto bei foodi.de hatten.</span><br />
        <br />
        Du kannst noch {{ couponBudget }} Gutscheine abrufen.<br />
        <input v-if="couponBudget" type="button" @click="getC4C()" class="mt-2 bg-green-heinz text-black py-3 px-2 mb-8 rounded cursor-pointer" value="Gutscheincode erstellen" /><br />
        <div v-if="couponForCoupon" class="inline-block my-4 p-4 border-2 border-green-heinz rounded text-center">
          Dein neuer Gutscheincode zum versenden lautet:<br />
          <span class="text-2xl font-bold">{{ couponForCoupon }}</span><br />
          <span class="text-sm">Wir haben dir den Code auch per E-Mail zukommen lassen</span>
        </div>
      </section>

      <h2 class="mt-12 border-0 text-xl">Kontaktdaten:</h2>
      <div>
        {{ user.item_firstname }} {{ user.item_lastname }}<br />
        {{ user.item_email }}<br />
        {{ user.item_phone }}<br />
        <a href="#" @click="editUser()" class="text-black">Kontaktdaten bearbeiten</a><br />
        <a href="#" @click="editPasswd()" class="text-black">Passwort ändern</a><br />
      </div>

      <useraddresses />

      <h2 class="mt-12 border-0 text-xl">Bestellhistorie ({{ archivedOrdersCount }}):</h2>
      <router-link v-if="archivedOrdersCount" to="/archiv" tag="button" class="bg-green-heinz mx-1 hover:bg-green-heinz-light text-black py-3 px-2 mb-8 rounded cursor-pointer">zur Bestellhistorie</router-link>
      <p v-if="!archivedOrdersCount">Es sind keine Bestellungen vorhanden. Beste Zeit das zu ändern 🔥</p>

      <div style="margin-top: 100px;" class="text-sm">
        Angemeldet seit {{ user.item_created }} Uhr<br />
        <a href="#" @click="removeUserModal()" class="text-black">Benutzeraccount löschen</a>
      </div>
    </template>
    <template v-if="isLoggedIn && !user.item_activated">
      <h1>Konto aktivieren</h1>
      <p>Bitte gib deinen Aktivierungs-Code ein, den wir dir nach der Registierung per SMS an die {{ user.item_phone }} gesendet haben.</p>
      <a v-if="!newCodeRequested" href="#" @click="resendActivation()" class="inline-block mt-2 text-black">Code nicht erhalten?</a><br />
      <a href="#" @click="editUser()" class="inline-block mt-2 text-black">Kontaktdaten bearbeiten?</a>
      <form v-on:submit.prevent="activateUser()">
        <div class="w-full mt-6 md:mb-0">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-activation">
            Aktivierungs-Code
          </label>
          <input v-model="activationCode" required type="text" class="block w-full max-w-xs text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-activation" />
        </div>
        <div class="w-full">
          <input type="submit" class="block w-full max-w-xs shadow bg-green-heinz hover:bg-green-heinz-light text-black mt-2 py-2 px-4 rounded" value="Konto aktivieren" />
        </div>
      </form>
    </template>
    <template v-if="!isLoggedIn">
      <h1 class="mb-6">Einstellungen</h1>
      <div class="mt-4  bg-orange-lightest border-l-4 border-orange text-orange-darker p-4 mb-4" role="alert">
        <p class="font-bold">Du bist nicht eingeloggt</p>
        <p>Bitte melde dich an um deine Einstellungen bearbeiten zu können.</p>
        <button @click="$parent.userLogin()" class="mt-4 shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded">jetzt anmelden</button>
      </div>
    </template>

    <dialog class="z-50 user-delete-dialog" name="userdelete" height="auto" id="user-delete-dialog">
      <div class="dialog__content">
      <h3 class="headline-extras">Benutzeraccount löschen</h3>
      <p>
        Schade, dass du uns verlassen möchtest 😭 <br />
        Bitte gib dein Passwort ein um deinen Benutzeraccount unwiderruflich zu löschen
      </p>

      <form v-on:submit.prevent="removeUser()">
        <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-password">
          Passwort
          <input v-model="loginData.password" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-password" type="password" placeholder="" />
        </label>

        <div class="flex w-full">
          <input type="button" v-on:click="closeDialog('user-delete-dialog')" class="block w-full mt-4 shadow bg-grey hover:bg-grey-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="abbrechen" />
          <div class="w-1/8"></div>
          <input type="submit" class="block w-full mt-4 shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="Konto löschen" />
        </div>
      </form>
      </div>
    </dialog>

    <dialog adaptive class="z-50 user-change-password-dialog" name="userchangepasswd" height="auto" id="user-change-password-dialog">
      <div class="dialog__content">
      <h3 class="headline-extras">Passwort ändern</h3>

      <form v-on:submit.prevent="editPasswdSubmit()">
        <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-passwordOld">
          Bisheriges Passwort
          <input v-model="loginData.password" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-passwordOld" type="password" placeholder="" />
        </label>

        <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-passwordNew">
          Neues Passwort
          <input v-model="loginData.passwordNew" required minlength="8" class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-passwordNew" type="password" placeholder="" />
        </label>

        <div class="flex w-full">
          <input type="button" v-on:click="closeDialog('user-change-password-dialog')" class="block w-full mt-4 shadow bg-grey hover:bg-grey-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="abbrechen" />
          <div class="w-1/8"></div>
          <input type="submit" class="block w-full mt-4 shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="speichern" />
        </div>
      </form>
      </div>
    </dialog>

    <dialog class="z-50 user-change-data-dialog" name="userchangedata" height="auto" id="user-change-data-dialog">
      <div class="dialog__content">
        <h3 class="headline-extras">Kontaktdaten bearbeiten</h3>

        <form v-on:submit.prevent="userUserSubmit()">
          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-first-name">
            Vorname
            <input v-model="userData.item_firstname" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-first-name" type="text" placeholder="" />
          </label>

          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-last-name">
            Nachname
            <input v-model="userData.item_lastname" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-last-name" type="text" placeholder="" />
          </label>

          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-email">
            E-Mail Adresse
            <input v-model="userData.item_email" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-email" type="text" placeholder="" />
          </label>

          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-phone-number">
            Handynummer
            <input v-model="userData.item_phone" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-phone-number" type="text" placeholder="" />
          </label>

          <div class="flex w-full">
            <input type="button" v-on:click="closeDialog('user-change-data-dialog')" class="block w-full mt-4 shadow bg-grey hover:bg-grey-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="abbrechen" />
            <div class="w-1/8"></div>
            <input type="submit" class="block w-full mt-4 shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-2 py-2 px-4 rounded cursor-pointer" value="speichern" />
          </div>
        </form>
      </div>
    </dialog>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import endpoints from '../../endpoints'
import axios from 'axios'
import UserAddresses from '../../components/UserAddresses.vue'
import { openDialog, closeDialog } from '../../utils/dialog'

export default {
  name: 'usersettings',

  data () {
    return {
      loginData: {
        password: '',
        passwordNew: ''
      },
      activationCode: '',
      newCodeRequested: false,
      userData: {},
      archivedOrdersCount: 0,
      couponForCoupon: '',
      couponBudget: 0
    }
  },

  components: {
    'useraddresses': UserAddresses
  },

  computed: {
    ...mapGetters([
      'user',
      'userLocations',
      'isLoggedIn'
    ])
  },

  created () {
    this.getArchivedOrdersCount()
    this.getC4CBudget()
  },

  methods: {
    ...mapActions([
      'deleteLocation',
      'deleteUser',
      'updateUserAccount',
      'updateUserPasswd',
      'resendActivationCode',
      'userActivation'
    ]),

    closeDialog,

    removeUserModal () {
      openDialog('user-delete-dialog')
    },

    removeUser () {
      closeDialog('user-delete-dialog')
      this.deleteUser(this.loginData)
    },

    editUser () {
      this.userData = {...this.user}
      openDialog('user-change-data-dialog')
    },

    userUserSubmit () {
      closeDialog('user-change-data-dialog')
      this.updateUserAccount(this.userData)
    },

    editPasswd () {
      openDialog('user-change-password-dialog')
    },

    editPasswdSubmit () {
      closeDialog('user-change-password-dialog')
      this.updateUserPasswd(this.loginData)
    },

    getArchivedOrdersCount () {
      axios.post(endpoints.archivedOrdersCount, { })
        .then(response => {
          this.archivedOrdersCount = response.data
        })
    },

    resendActivation () {
      if (window.confirm('Möchtest du den Code erneut per SMS zugesendet bekommen?')) {
        this.newCodeRequested = true
        this.resendActivationCode()
      }
    },

    activateUser () {
      this.userActivation(this.activationCode)
    },

    getC4CBudget () {
      axios.post(endpoints.userGetC4CBudget, { })
        .then(({ data }) => {
          this.couponBudget = data.budget
        })
    },

    getC4C () {
      axios.post(endpoints.getCouponForCoupon, { })
        .then(({ data }) => {
          if (data.success) {
            this.couponForCoupon = data.code
            this.getC4CBudget()
          } else {
            if (data.error) {
              alert(data.error)
            }
            this.couponForCoupon = ''
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/index.vue